var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":"error"},on:{"click":function($event){return _vm.$router.go(-1)}}},'v-btn',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.$t('buttons.back'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }